function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from "react";
import { floral } from "@thebouqs/system";
import { Overlay } from "@thebouqs/overlay";
export var DrawerMain = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    open,
    children,
    onOverlayClick,
    overlayColor
  } = props,
      drawerProps = _objectWithoutPropertiesLoose(props, ["open", "children", "onOverlayClick", "overlayColor"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, open ? /*#__PURE__*/React.createElement(Overlay, {
    onClick: onOverlayClick,
    color: overlayColor
  }) : null, /*#__PURE__*/React.createElement(floral.div, _extends({
    ref: ref
  }, drawerProps), children));
});
//# sourceMappingURL=DrawerMain.js.map